import { Link } from "react-router-dom";
import { categories } from "@/mocks/products";

export default function CategoriesSection() {
  return (
    <section className="py-14 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">Explorar por Categoria</h2>
            <p className="text-gray-500 text-sm mt-1">Encontre o que você precisa rapidamente</p>
          </div>
          <Link
            to="/categorias"
            className="hidden md:flex items-center gap-2 text-orange-500 hover:text-orange-600 font-semibold text-sm transition-colors"
          >
            Ver todas
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categoria/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl aspect-square cursor-pointer"
            >
              <div className="w-full h-full">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent group-hover:from-black/90 transition-all duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-500 mb-2">
                  <i className={`${cat.icon} text-white text-sm`}></i>
                </div>
                <p className="text-white font-bold text-sm leading-tight">{cat.name}</p>
                <p className="text-white/60 text-xs">{cat.count.toLocaleString("pt-BR")} produtos</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-4 md:hidden text-center">
          <Link
            to="/categorias"
            className="inline-flex items-center gap-2 text-orange-500 font-semibold text-sm"
          >
            Ver todas as categorias
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
